import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DateRange,
  OrgaUserSummary,
  PositionSummary,
  ProjectSummary,
  WorkFilter,
} from '@jessie/commons';

import { SimplePillComponent } from '../../../../../components/filterpills/simple-pill.component';
import { DateFilterPillComponent } from '../../../../../components/filterpills/date-filter-pill.component';

@Component({
    selector: 'app-work-table-filter',
    templateUrl: './work-table-filter.component.html',
    imports: [SimplePillComponent, DateFilterPillComponent]
})
export class WorkTableFilterComponent {
  @Input()
  filter: WorkFilter = {
    project: null,
    position: null,
    user: null,
    date: { type: 'notSet' },
  };

  @Input()
  projectFilterValues: ProjectSummary[] = [];
  @Input()
  positionFilterValues: PositionSummary[] = [];
  @Input()
  userFilterValues: OrgaUserSummary[] = [];

  @Input()
  showFilter: ('project' | 'position' | 'user')[] = [];

  @Output()
  filterChanged = new EventEmitter<WorkFilter>();

  dateChanged(dateRange: DateRange) {
    this.filterChanged.emit({
      ...this.filter,
      date: dateRange,
    });
  }

  projectChanged(filter: ProjectSummary | null) {
    this.filterChanged.emit({
      ...this.filter,
      project: filter,
    });
  }
  positionChanged(filter: PositionSummary | null) {
    this.filterChanged.emit({
      ...this.filter,
      position: filter,
    });
  }
  userChanged(filter: OrgaUserSummary | null) {
    this.filterChanged.emit({
      ...this.filter,
      user: filter,
    });
  }
}
